import { render, staticRenderFns } from "./DashboardFeedbackJSCode.vue?vue&type=template&id=016ae8ee&scoped=true&"
import script from "./DashboardFeedbackJSCode.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedbackJSCode.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedbackJSCode.vue?vue&type=style&index=0&id=016ae8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ae8ee",
  null
  
)

export default component.exports